import { formDataRequest, postRequest } from '../libs/AxiosService.util';

export async function serviceCreateClient(params) {
    return await formDataRequest('clients/create', params);
}

export async function serviceUpdateClient(params) {
    return await formDataRequest('clients/update', params);
}

export async function serviceFetchClient(params) {
    return await postRequest("clients", params);
}

export async function serviceClientDetail(params) {
    return await postRequest("clients/detail", params);
}
export async function serviceDeleteClient(params) {
    return await postRequest("clients/delete", params);
}

export async function serviceGetClientsProgram(params) {
    return await postRequest("programs", params);
}
export async function serviceClientIsExist (params) {  
    return await postRequest('clients/check', params);
}
